let x = $;
/*
 * Digital Purchase Order
 *
 * Copyright (c) 2017 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */

import DOMPurify from "dompurify";

$.views.helpers({
	currentUser: () => API.User,
	mergeClasses: function() {
		if (arguments.length == 0) {
			return '';
		}

		return Array.prototype.slice.call(arguments).join(' ');
	},
	globalizeCalendarPattern: function() {
		var finalPattern = '';
		for (var i = 0; i < arguments.length; i++) {
			var pattern = arguments[i];

			if (pattern.length != 1 || !Globalize.culture().calendar.patterns[pattern]) {
				finalPattern += pattern;
			} else {
				finalPattern += Globalize.culture().calendar.patterns[pattern];
			}
		}

		return finalPattern;
	},
	formatDate: function(date, format) {
		return Globalize.format(date, format);
	},
	IsNotEmpty: function(value) {
		if (value === null || typeof value === 'undefined' || (typeof value === 'string' && value.trim().length == 0)) {
			return false;
		}

		return true;
	},
	fileIcon: function(mimeType) {

		if (mimeType.substring(0,5) == 'image') {
			return 'fa fa-file-image-o';
		} else if (mimeType.substr(0,5) == 'text') {
			return 'fa fa-file-text-o';
		} else if (mimeType.substr(0,5) == 'video') {
			return 'fa fa-file-video-o';
		} else if (mimeType.substr(0,5) == 'audio') {
			return 'fa-file-audio-o';
		} else {


			switch (mimeType) {
				case 'application/pdf':
				case 'application/postscript':
					return 'fa-file-pdf-o';
					break;
				case 'application/zip':
				case 'application/x-gtar':
				case 'application/x-tar':
				case 'application/gzip':
					return 'fa-file-archive-o';
					break;
				case 'application/msexcel':
				case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
				case 'application/vnd.msexcel':
				case 'application/vnd.ms-excel.sheet.macroEnabled.12':
					return 'fa-file-excel-o';
					break;

				case 'application/msword':
				case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
				case 'application/vnd.ms-word.document.macroEnabled.12':
				case 'application/vnd.msword':
					return 'fa-file-word-o';
					break;
				case 'application/mspowerpoint':
				case 'application/vnd.mspowerpoint':
				case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
				case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
				case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
					return 'fa-file-powerpoint-o';
					break;
				default:
					return 'fa-file-o';
			}
		}
	},
});

$.views.converters({
	purify: (value) => DOMPurify.sanitize(value),
	mailto: function(value) {
		let urlValue = 	$.views.converters.url(value);

		return 'mailto:' + urlValue;
	},
	nl2space: function(value) {
		if (!value) return null;
		return value.replace(new RegExp('(s*(\n|\r|\r\n))+', 'g'), ' ');
	},
	nl2spaceHtml: function(value) {
		return $.views.converters.nl2space($.views.converters.html(value));
	},
	nl2br: function (value) {
		var htmlValue = $.views.converters.html(value);
		return htmlValue.replaceAll('\n', '<br>');
	},
	boolToStr: function(value, context) {
		var nullable = this.tagCtx.props.nullable

		if (typeof(nullable) == 'undefined') {
			nullable = false;
		}

		if (nullable && value === null ) {
			return "";
		}
		return (value ? "true":"false");
	},
	strToBool: function(value, context) {
		var nullable = this.tagCtx.props.nullable

		if (typeof(nullable) == 'undefined') {
			nullable = false;
		}

		if (nullable && (value === null || value == "")) {
			return null;
		}
		return ($.trim(value) == "true");
	},
	floatToStr: function(value, context) {
		if (value !== 0 && (value == "" || !value)) {
			return null;
		}

		value = parseFloat(value);

		var maxPrecision = this.linkCtx.elem.getAttribute('data-precision') || 2;
		var minPrecision = this.linkCtx.elem.getAttribute('data-min-precision') || 0;

		return Globalize.format(value, Globalize.getNumberFormat(value, {
			MinimumFractionDigits: minPrecision,
			MaximumFractionDigits: maxPrecision
		}));

		// return Globalize.format(value, "n" + precision);
	},
	strToFloat: function(value, context) {

		var nullable = this.tagCtx.props.nullable

		if (typeof(nullable) == 'undefined') {
			nullable = true;
		}
		if (value == "") {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		var float = Globalize.parseFloat(value);

		if (isNaN(float)) {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		return float;
	},
	unixtime2ShortDate: function(value, context) {
		return Globalize.format(new Date(value * 1000), 'd');

	},
	shortDate2unixtime: function(value, context) {
		var date = Globalize.parseDate(value, 'd');

		return date.getTime() / 1000;
	},
	date2string: function(value) {
		if (!value || !(value instanceof Date)) {
			return null;
		}
		var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;

		return Globalize.format(value, format);
	},
	string2date: function(datestr) {
		if (!datestr) {
			return null;
		}

		if (datestr.slice(-1) == 'Z') {
			datestr = datestr.substring(0, datestr.length - 1) + '+00:00';
		}
		var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;
		var date = Globalize.parseDate(datestr, format);

		if (!date) {
			return null;
		}

		return date;
	},
	apidate2string: function(value) {
		if (!value) {
			return null;
		}
		var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;

		var date = null;

		if (value.Timestamp) {
			date = new Date(value.Timestamp * 1000)
		}

		if (!date) {
			return null;
		}

		return Globalize.format(date, format);

	},
	string2apidate: function(datestr) {
		if (!datestr) {
			return null;
		}
		var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;
		var date = Globalize.parseDate(datestr, format);

		if (!date) {
			return null;
		}

		return {
			Timestamp: date.getTime() / 1000,
			Formatted:  Globalize.format(date, Globalize.culture().calendar.patterns.d + ' ' + Globalize.culture().calendar.patterns.t)
		};
	},
	setBit: function(value) {
		// "Convert Back": If checked, set this bit on the data,
		// or if unchecked, unset this bit on the data
		var mask = 1 << this.linkCtx.elem.getAttribute("data-bit"),
			// Shift first bit, 0, 1 or 2 bits to the left,
			// to create a mask
			dataValue = this.tagCtx.args[0];
		// Take the current data value
		return value ? (dataValue | mask) : (dataValue & ~mask);
		// Use the mask to set or unset that bit on the data,
		// and return the modified value
	},
	getBit: function(value) {
		// "Convert": Get the bit from the data,
		// and check or uncheck the checkbox
		return (value >>
			this.linkCtx.elem.getAttribute("data-bit") & 1) === 1;
		// Shift 0, 1 or 2 bits to the right,
		// and see if the first bit is set.
	},
	toNum: function (val) {
		if (/^\s*$/.test(val)) {
			return null;
		}

		return +val;
	},
	trim: function (val) {
		if (/^\s*$/.test(val)) {
			return null;
		}

		return val.trim();
	},
	toInt: function(value) {
		let nullable = this.tagCtx.props.nullable

		if (typeof(nullable) == 'undefined') {
			nullable = true;
		}
		if (value == "") {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		let int = Globalize.parseInt(value);

		if (isNaN(int)) {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		return int;
	},
	/*mergeclass: function(value, context) {
		var elem =$(context.tgt);
		var toggleClasses = (elem.attr('data-merge-class') ? elem.attr('data-merge-class').split(' '):[]);
		var classes = elem.attr('class');


		$.each(toggleClasses, function(index, cls) {
			if (cls.trim().length > 0) {
				if (value) {
					// add class
					if (classes.indexOf(cls) < 0) {
						classes = classes + ' ' + cls;
					}
				} else {
					if (classes.indexOf(cls) > -1) {
						classes.replace(cls,'');
					}
				}
			}
		});
		return classes;
	},*/
	isInArray: function(value, context) {
		// "Convert": check whether item is in given array
		var ctrlValue = this.linkCtx.elem.value; //context.tgt.value;
		return ($.inArray(ctrlValue, value) !== -1);
	},
	addToArray: function(value, context) {
		// "Convert Back": add value to Array if set, otherwise remove

		if (!$.isArray(this.tagCtx.args[0])) {
			this.tagCtx.args[0] = [];
		}

		var arr = this.tagCtx.args[0];
		var itemValue = this.linkCtx.elem.value;

		if (value) {
			// add to array
			if($.inArray(itemValue, arr) === -1) {
				$.observable(arr).insert(itemValue);
				// arr.push(itemValue);
			}
		} else {
			var pos = $.inArray(itemValue, arr);

			if (pos !== -1) {
				$.observable(arr).remove(pos,  1);
				// arr.splice(pos,1);
			}

		}
		return arr;
	},
	arrayFirstValue: function(value, context) {
		// "Convert": check whether item is in given array
		if (!$.isArray(value) || (value.length == 0)) {
			return null;
		}
		return value[0];
	},
	toSingleArray: function(value, context) {
		// "Convert Back": add value to Array if set, otherwise remove
		var arr = this.tagCtx.args[0];
		var itemValue = this.linkCtx.elem.value;

		if (value) {
			return [itemValue];
		} else {
			return[];

		}
	},

	getTranslation: function(val, arg1) {

		let nl2space = this.tagCtx.props.nl2space;

		if (!$.isArray(val)) {
			return null;
		}

		// get language ID to retrieve
		var languageID = this.linkCtx.elem.getAttribute("data-language-id");
		var prop = this.linkCtx.elem.getAttribute("data-language-prop");

		if (!prop) {
			prop = 'Text';
		}
		// find translation object
		var translObj = val.filter(function(item) {
			return item.LanguageID == languageID;
		});

		if (!translObj || !translObj.length) {
			return null;
		}

		translObj = translObj[0];

		if (nl2space && translObj[prop]) {
			return translObj[prop].replaceAll('\n',' ');
		}
		return translObj[prop];
	},
	setTranslation: function(val, arg1) {
		if (!$.isArray(this.tagCtx.args[0])) {
			this.tagCtx.args[0] = [];
		}

		// get language ID to retrieve
		var languageID = this.linkCtx.elem.getAttribute("data-language-id");
		let prop = this.linkCtx.elem.getAttribute("data-language-prop");


		if (!prop) {
			prop = 'Text';
		}

		var arr = this.tagCtx.args[0];

		// find translation object
		var translObj = arr.filter(function(item) {
			return item.LanguageID == languageID;
		});

		if (!translObj || !translObj.length) {
			translObj = {
				LanguageID: languageID,
			};

			translObj[prop] = null;
		} else {
			translObj = translObj[0];
		}

		// translObj[prop] = val
		$.observable(translObj).setProperty(prop, val);

		if (val) {
			// add to array
			if($.inArray(translObj, arr) === -1) {
				// arr.push(translObj);
				$.observable(arr).insert(translObj);
			}
		} else {
			// remove from array
			var pos = $.inArray(translObj, arr);

			if (pos !== -1) {
				// arr.splice(pos,1);
				$.observable(arr).remove(pos, 1);
			}

		}

		let triggerRefresh = this.tagCtx.props.doRefresh;
		try {
			this.linkCtx.view.refresh();
		} catch(e){}
		return arr;
	},
	decorate: function(value) {
		let prepend = this.tagCtx.props.prepend || '';
		let append = this.tagCtx.props.append || '';

		if (!value) {
			return value;
		}

	    return prepend + value  +  append;
	},
	join: function (...values) {
		let separator = this.tagCtx.props.separator || undefined;
		let onEmpty = this.tagCtx.props.onEmpty || undefined;

		values = values.filter((v) => !stringEmpty(v));

		if (!values.length && !stringEmpty(onEmpty)) {
			return onEmpty;
		}
		return values.join(separator);

	}
});

$.observable.Object.prototype.setPropertyR = function (newData) {
	for (var prop in newData) {
		if (prop.startsWith('jQuery')) {
			continue;
		}

		if (!this._data || typeof this._data[prop] == 'undefined' || this._data[prop] === null) {
			// brand new property
			this.setProperty(prop, newData[prop]);
		} else {
			// existing, non null-property
			if ($.isArray(newData[prop]) && $.isArray(this._data[prop])) {
				// replace array with array content
				$.observable(this._data[prop]).refresh(newData[prop]);
			} else if (newData[prop] !== null && typeof newData[prop] == 'object' && typeof this._data[prop] == 'object' && !$.isArray(this._data[prop]) && !(this._data[prop] instanceof Date)) {
				// merge subobject
				$.observable(this._data[prop]).setPropertyR(newData[prop]);
			} else {
				// set / replace value
				this.setProperty(prop, newData[prop]);
			}
		}
	}
};

export {x}
